import { DEFAULT_MOVEMENTS, type Movement } from "./movements";

export const STORAGE_KEY_CONFIG = 'pomotion_config';

export type TimerConfig = {
	durationMins: number;
	shortBreakMins: number;
	movementBreakMins: number;
	movementBreakFrequency: number;
	soundEnabled: boolean;
	movements: Movement[];
}

const DEFAULT_CONFIG: TimerConfig = {
	durationMins: 25,
	shortBreakMins: 5,
	movementBreakMins: 10,
	movementBreakFrequency: 4,
	soundEnabled: true,
	movements: DEFAULT_MOVEMENTS
};

export function loadConfig(): TimerConfig {
	const config = localStorage.getItem(STORAGE_KEY_CONFIG);

	if (!config) {
		saveConfig(DEFAULT_CONFIG);
		return DEFAULT_CONFIG;
	}

	return validateConfig({ ...DEFAULT_CONFIG, ...JSON.parse(config) });
}

export function saveConfig(config: TimerConfig): void {
	localStorage.setItem(STORAGE_KEY_CONFIG, JSON.stringify(validateConfig(config)));
}

export function validateConfig(config: TimerConfig): TimerConfig {
	return {
		...config,
		durationMins: Math.max(1, Math.min(90, config.durationMins)),
		shortBreakMins: Math.max(1, Math.min(30, config.shortBreakMins)),
		movementBreakMins: Math.max(1, Math.min(30, config.movementBreakMins)),
		movementBreakFrequency: Math.max(1, Math.min(10, config.movementBreakFrequency)),
	};
}
